<template>
	<CModal
		:show.sync="resModal"
		class="disable-footer disable-header"
		centered
		fade
		color="primary"
		borderColor="primary"
		:closeOnBackdrop="false"
	>
		<div class="popup-header" style="height: 25px">
			<h5 class="modal-title"></h5>
			<button type="button">
				<!-- <CIcon name="cil-x" /> -->
			</button>
		</div>
		<br />
		<center>
			<template v-if="resMessage">
				{{ resMessage }}
			</template>
			<template v-else> Something went wrong, Please try again!! </template>
			<div class="inactive-modal-response">
				<CButton
					type="submit"
					color="primary"
					class="m-1"
					@click="responseHandler"
					>Ok</CButton
				>
			</div>
		</center>
	</CModal>
</template>

<script>
export default {
	name: "Modal",
	props: {
		modal: Boolean,
		message: String,
		color: String,
	},
	data() {
		return {
			resModal: this.modal,
			resMessage: this.message,
		};
	},
	watch: {
		modal() {
			this.resModal = this.modal;
		},
		message() {
			this.resMessage = this.message;
		},
	},

	methods: {
		responseHandler() {
			this.resModal = false;
			this.$emit("res-handler", this.resModal);
		},
		closeHandler() {
			this.$emit("close");
		},
	},
};
</script>